import { z } from 'zod'

// const stringFilterSchema = z.union([
//   z.object({
//     equals: z.string(),
//   }),
//   z.object({
//     contains: z.string(),
//   })
// ])

export const stringFilterSchema = z.object({
  contains: z.string().optional(),
})

export const stringInFilterSchema = z.object({
  in: z.string().array().optional(),
})

export const numberFilterSchema = z.object({
  gte: z.number().optional(),
  lte: z.number().optional(),
})

export const dateTimeFilterSchema = z.object({
  gte: z.string().optional(),
  lte: z.string().optional(),
})

export const nullFilterSchema = z.object({
  isNull: z.boolean().optional(),
})
